import mainComponent from './main.component';
import Settings from '../settings'
import Access_denied from '../access_denied'
let mainModule = angular.module('main', [
    Settings,
    Access_denied
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/app');

    $stateProvider
      .state('app', {
        url: '/app',
        component: 'app',
        data: {
          requireLogin: true
        },
        resolve: {
          getACL: ($q, UserService, User, $state) => {
            let de = $q.defer()
            UserService.acl()
              .then((data) => {
                User.setACL(data);
                de.resolve('done');
              })
              .catch((err) => {
                de.reject($state.target('login', undefined, {
                  location: true
                }));
              })

            return de.promise;
          }
        }
      })
  })

  .component('main', mainComponent)

  .name;

export default mainModule;


// WEBPACK FOOTER //
// ./client/app/components/main/index.js